import { createBrowserRouter, Navigate } from "react-router-dom";
import ManageUsersPage from "features/manage-users/presentation/manageUsers.page";
import UserAccountsPage from "features/user-accounts/presentation/userAccounts.page";
import { AccountPage } from "features/account/presentation/account.page";
import { LoginPage } from "features/auth/presentation/login.page";
import { UpdatePasswordPage } from "features/auth/presentation/updatePassword.page";
import { ResetPasswordPage } from "features/auth/presentation/resetPassword.page";
import { ForgotPasswordValidationPage } from "features/auth/presentation/forgotPasswordValidation.page";
import PrivateLayout from "core/layout/private.layout";
import AccountLayout from "core/layout/account.layout";
import { AccountDashboardPage } from "features/user-accounts/presentation/account-dashboard.page";
import { AdHocReportPage } from "features/ad-hoc-dashboard/ad-hoc-report.page";
import { MainLayout } from "core/layout/main.layout";
import AdminRouteWidget from "core/widgets/adminRoute.widget";
import paths from "paths";
import { AuthLayout } from "core/layout/auth.layout";
import ReportsPage from "pages/Reports.page";
import ErrorElementPage from "core/pages/ErrorElement.page";
import { ProjectsPage } from "features/ad-hoc-projects/projects.page";
import { FeatureFlag } from "core/components/feature-flag";
import { AudiencesPage } from "features/ad-hoc-audiences/audiences.page";

export const messages = [
  {
    path: paths.open.RESET,
    header: "Forgot your password?",
    message:
      "Enter your account email address to receive a reset password link",
  },
  {
    path: paths.open.UPDATE,
    header: "Account Setup",
    message: "Enter your new password",
  },
  {
    path: paths.open.LOGIN,
    header: "Welcome",
    message: "Log in to access your dashboard.",
  },
  {
    path: paths.open.FORGOT,
    header: "Reset password",
    message: "Enter your new password",
  },
];

const admin = [
  {
    path: paths.admin.MANAGE_USERS,
    element: <ManageUsersPage />,
  },
];

const authenticated = [
  {
    element: <Navigate to={paths.open.LOGIN} />,
    index: true,
    path: "/",
  },
  {
    element: <MainLayout />,
    children: [
      {
        path: paths.authenticated.USER_ACCOUNTS,
        element: <UserAccountsPage />,
      },
      {
        path: paths.authenticated.ACCOUNT,
        element: <AccountPage />,
      },
      {
        path: paths.authenticated.REPORTS,
        element: <ReportsPage />,
      },
      {
        path: paths.authenticated.PROJECTS,
        children: [
          {
            index: true,
            element: <ProjectsPage />,
          },
          {
            path: ":projectId",
            children: [
              {
                path: paths.authenticated.AUDIENCES,
                element: <AudiencesPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: paths.authenticated.USER_ACCOUNTS + "/:id",
    element: <AccountLayout />,
    children: [
      {
        element: <AccountDashboardPage />,
      },
      {
        // These are really the monthly transactions available to download
        path: paths.authenticated.REPORTS,
        element: <ReportsPage />,
      },
      {
        path: paths.authenticated.DASHBOARD,
        element: <AccountDashboardPage />,
      },
      {
        path: paths.authenticated.PROJECTS,
        element: <ProjectsPage />,
      },
      {
        // AdHoc Accounts (old, legacy supported)
        path: paths.authenticated.ADHOC_REPORT + "/:contextId",
        element: <AdHocReportPage />,
      },
      {
        path: paths.authenticated.PROJECTS + "/:projectId",
        children: [
          {
            path: paths.authenticated.AUDIENCES,
            element: <AudiencesPage />,
          },
          {
            // AdHoc Accounts
            path: paths.authenticated.REPORTS + "/:contextId",
            element: <AdHocReportPage />,
          },
        ],
      },
    ],
  },
  {
    element: <AdminRouteWidget />,
    children: admin,
  },
];

const open = [
  {
    path: paths.open.FORGOT + "/:code",
    element: <ForgotPasswordValidationPage />,
  },
  {
    path: paths.open.UPDATE,
    element: <UpdatePasswordPage />,
  },
  {
    path: paths.open.LOGIN,
    element: <LoginPage />,
  },
  {
    path: paths.open.RESET,
    element: <ResetPasswordPage />,
  },
];

const router = createBrowserRouter([
  {
    errorElement: <ErrorElementPage />,
    children: [
      {
        element: <PrivateLayout />,
        children: authenticated,
      },
      {
        element: <AuthLayout />,
        children: open,
      },
      {
        element: <Navigate to={paths.authenticated.USER_ACCOUNTS} />,
        path: "*",
      },
    ],
  },
]);

export { router };
